'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Icon = require('../../icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

require('./FormPrimaryMessage.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Components
var FormPrimaryMessage = function FormPrimaryMessage(_ref) {
    var icon = _ref.icon,
        message = _ref.message,
        children = _ref.children,
        show = _ref.show,
        className = _ref.className;

    if (!show) return null;

    return _react2.default.createElement(
        'p',
        { className: (0, _classnames2.default)('FormPrimaryMessage', className) },
        icon ? _react2.default.createElement(_Icon2.default, { name: icon }) : null,
        message,
        children
    );
};

// Styles
// Lib


FormPrimaryMessage.propTypes = {
    message: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    show: _propTypes2.default.bool,
    className: _propTypes2.default.string,
    children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node])
};

exports.default = FormPrimaryMessage;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/form/messages/FormPrimaryMessage.js
// module id = 701
// module chunks = 0